import script from "./ComunicacaoQueda.vue?vue&type=script&setup=true&lang=js"
export * from "./ComunicacaoQueda.vue?vue&type=script&setup=true&lang=js"

import "./ComunicacaoQueda.vue?vue&type=style&index=0&id=58354c7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58354c7f"]])

export default __exports__